<template>
    <div class="row">
        <EventCard v-for="(rdv, index) in rdvsToCome" :key="index" :rdv="rdv" :detail="detail" @delete-rdv="handleDelete" @edit-rdv="handleEdit"></EventCard>
    </div>
</template>

<script>
    import EventCard from "./EventCard.vue";
    import axios from "axios";
    import { toast } from "bulma-toast";
    import { BookingStore } from "../Stores/BookingStore";
    export default {
        name : "MesRendezVous",
        props : ['rdvsToCome', 'fo_config'],
        components : { EventCard },
        emits : ['cancel-rdv'],
        computed: {
            config() {
                return this.$page.props.config
            },
            redirected(){
                return this.fo_config && (this.fo_config['redirected'] == 1);
            }, 
        },
        data() {
            return {
                detail: 'incoming',
                rdvToCancel: null,
            }
        },
        methods: {
            handleEdit(rdv) {
                if (this.canCancelRdv(rdv)) {
                    BookingStore.rdvToModify = rdv
                    console.log('Booking Store rdvToModify ----->',BookingStore.rdvToModify);
                    this.$inertia.get('/booking')
                }
            },
            handleDelete(rdv) {
                console.log("Received Emit") 
                console.log(this.config)
                if (this.canCancelRdv(rdv)) {
                    this.rdvToCancel = rdv.rdv_id
                    this.$emit('cancel-rdv', this.rdvToCancel)
                    console.log("Emit Sent", this.rdvToCancel)
                    // this.$inertia.get('/booking')
                }
                else {
                    toast({
                        message: err?.response?.data?.message || 'Une erreur a empeché la suppression du rendez-vous.',
                        type: 'is-danger',
                        duration: 5000,
                        pauseOnHover: true
                    })
                }
            },
            canCancelRdv(rdv) {
                if (!this.config.allow_client_delete_rdv) return false
                if (!this.config.last_annulation_time) return true
                let date_rdv = moment().add(this.config.last_annulation_time, 'hours')
                return date_rdv.isBefore(moment(rdv.start_date).format('YYYY-MM-DD HH:mm:ss'))
            },
            // cancelRdv() {
            //     if (!this.rdvToCancel) return false
            //     axios.delete('/rdv/'+ this.rdvToCancel).then(response => {
            //         this.rdvsToCome = this.rdvsToCome.filter(rdv => rdv.rdv_id != this.rdvToCancel)
            //         toast({
            //             message: 'Votre rendez-vous a bien été annulé.',
            //             type: 'is-success',
            //             duration: 3000,
            //             pauseOnHover: true
            //         })
            //     }).catch(err => {
            //         toast({
            //             message: err?.response?.data?.message || 'Une erreur a empeché la suppression du rendez-vous.',
            //             type: 'is-danger',
            //             duration: 5000,
            //             pauseOnHover: true
            //         })
                // })
            // },
        },
    }

</script>